<!--  -->
<template>
  <div>
    <div style="margin-bottom:10px" class="search_box">
      <el-input v-model="pageIfon.keywords" style="width:200px;s" placeholder="gh_id/appid" />
      <el-button icon="el-icon-search" type="primary" style="max-height:37px" @click="(pageIfon.page = 1),(resultlist())">搜索</el-button>
      <el-button icon="el-icon-refresh-left" type="primary" style="max-height:37px" @click="reset">重置</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="gh_id"
        label="ghId"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appid"
        align="center"
      />
      <el-table-column
        prop="bind_status_text"
        label="绑定状态"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.bind_status_text }}</span>
          <el-button v-if="scope.row.bind_status == 1 && scope.row.status == 1" style="margin-left:10px" type="primary" size="mini" @click="updatareash(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.bind_status == 3 && scope.row.status == 1" style="margin-left:10px" type="primary" size="mini" @click="updatareash(scope.row)">刷新</el-button>
          <el-button v-if="scope.row.bind_status == 4 && scope.row.status == 1" style="margin-left:10px" type="primary" size="mini" @click="updatareash(scope.row)">刷新</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="发送状态"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="publishId"
        label="发送任务id"
        width="180"
        align="center"
      /> -->
      <el-table-column
        prop="bind_time_text"
        label="绑定时间"
        align="center"
      />
      <el-table-column
        prop="bind_err_info"
        label="失败原因"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.bind_status == 2 && scope.row.status == 1 && item.status!=2" type="danger" size="mini" @click="stoprwe(scope.row)">停止推送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { boundaccountslist, fetchres, updataaccountpushstate } from '@/api/sourceMaterial.js'
import { stopOneSend } from '@/api/stwert.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10,
        keywords: null
      },
      total: null,
      tableData: [],
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val, item) {
      console.log('val', val)
      this.id = val
      this.item = item
      this.resultlist()
    },
    async resultlist() {
      const data = await boundaccountslist({
        ...this.pageIfon,
        id: this.id
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    async loojser(item) {
      const data = await fetchres({
        id: item
      })
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.resultlist()
      console.log('data', data)
    },
    async updatareash(item) {
      console.log('item', item)
      try {
        const data = await updataaccountpushstate({
          push_articles_template_id: item.push_articles_template_id,
          articles_template_id: item.articles_template_id,
          app_id: item.app_id
        })
        this.$message({
          type: 'success',
          message: '刷新成功!'
        })
        console.log('data', data)
        this.resultlist()
      } catch {
        console.log('err')
        this.resultlist()
      }
    },
    reset() {
      this.pageIfon = {
        page: 1, // 页码
        pageSize: 10, // 页数
        keywords: null // 用户openid
      }
      this.resultlist()
    },
    stoprwe(item) {
      console.log(item)
      this.$confirm('此操作将停止推送, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        stopOneSend({
          app_id: item.app_id,
          push_articles_template_id: this.item.id
        }).then((res) => {
          this.resultlist()
          this.$emit('updata')
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停止'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
